module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sk-11ccabc61bfafb47ca27ad6f1925e0fc.svg";